import { FunctionComponent } from 'react';
import styles from './Counter.module.scss';

export type CounterProps = {
  counts: number;
};

type FC = FunctionComponent<CounterProps>;

const Counter: FC = ({ counts }: CounterProps) => (
  <div className={styles.counter}>
    <span>{counts}</span>
  </div>
);

export default Counter;
